import React from 'react';
import PropTypes from 'prop-types';
import HeatmapSettingsButton from '@Containers/ResultToolbar/HeatmapSettingsButton';
import HeatmapNavigatorButton from '@Containers/ResultToolbar/HeatmapNavigatorButton';
import HeatmapLegendButton from '@Containers/ResultToolbar/HeatmapLegendButton';
import HeatmapBackToResultsButton from '@Containers/ResultToolbar/HeatmapBackToResultsButton';
import HeatmapFullScreenButton from '@Containers/ResultToolbar/HeatmapFullScreenButton';
import ExportButton from '../ExportButton';
import LimitToButton from '../LimitToButton';
import ExcludeButton from '../ExcludeButton';
import ResultToolbarHeatmapTopSection from './ResultToolbarHeatmapTopSection';

import './ResultToolbarHeatmapView.custom.scss';

export default function ResultToolbarHeatmapView(props) {
  const { children } = props;

  return (
    <header className="result-toolbar result-toolbar-heatmap rx-right-gutter">
      {children}
      <ResultToolbarHeatmapTopSection {...props} />
      <section className="result-toolbar-bottom-section">
        <section className="result-toolbar-heatmap-controls-left">
          <LimitToButton {...props} />
          <ExcludeButton {...props} />
          <ExportButton {...props} />
          <HeatmapSettingsButton {...props} />
          <HeatmapNavigatorButton {...props} />
          <HeatmapLegendButton {...props} />
        </section>
        <section className="result-toolbar-heatmap-controls-right">
          <HeatmapBackToResultsButton {...props} />
          <HeatmapFullScreenButton {...props} />
        </section>
      </section>
    </header>
  );
}

ResultToolbarHeatmapView.propTypes = {
  children: PropTypes.node,
};
